import { useAppSelector } from '@/redux/hooks'
import { useSelectedEcommerceIds } from './use-selected-ecommerce-ids'

// Read-only on purpose. Dispatching the first portal when none is selected wrote the navbar's
// "All" away from every page that mounted a caller; a page that needs one portal falls back here,
// to the first store of the selected group when there is one.
export function useEcommerceId() {
  const ecommercesList = useAppSelector(
    (store) => store.userApi.getMe.response.user?.e_commerces_ids
  )
  const selectedIds = useSelectedEcommerceIds()

  return selectedIds?.[0] || ecommercesList?.[0]
}
